import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPlaceholder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.958 14.75 9.833 54.083h44.25L31.958 14.75Zm0 20.057-5.311 9.443H37.27l-5.312-9.443Z"
        fill="#0F172A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m83.44 73.473-10.607 10.25 10.25 10.607L93.69 84.08 83.44 73.473ZM58.928 83.486l23.917 24.748 24.748-23.917-23.917-24.748-24.748 23.917Z"
        fill="#00664F"
      />
      <path
        d="m83.677 59.569 23.917 24.748-24.748 23.918L58.93 83.486 83.677 59.57Zm-.807 47.252 23.31-22.528-22.527-23.31-23.31 22.527 22.527 23.311Zm12.233-22.717L83.06 95.744 71.419 83.7l12.044-11.64 11.64 12.044ZM83.083 94.33l10.606-10.25-10.25-10.607-10.606 10.25 10.25 10.607Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.333 78.667h-14.75v14.75h14.75v-14.75ZM14.75 68.833v34.417h34.417V68.833H14.75Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.583 44.25c5.431 0 9.834-4.403 9.834-9.833 0-5.431-4.403-9.834-9.834-9.834-5.43 0-9.833 4.403-9.833 9.834 0 5.43 4.403 9.833 9.833 9.833Zm0 9.833c10.862 0 19.667-8.805 19.667-19.666 0-10.862-8.805-19.667-19.667-19.667-10.861 0-19.666 8.805-19.666 19.667 0 10.861 8.805 19.666 19.666 19.666Z"
        fill="#599F40"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPlaceholder)
